import React, { useEffect, useRef } from 'react'

import buttonVariantMacher from '../../interfaces/ButtonVariantMacher'
import { HeadingSizeEnum } from '../Heading/Heading'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import NormalizeMedia from '../../utils/NormalizeMedia'
import alignmentMatcher from '../../interfaces/AligmentMatcher'

import {
  StyledBody,
  StyledButton,
  StyledButtonDownload,
  StyledButtons,
  StyledCard,
  StyledHeading,
  StyledImage,
  StyledLabel,
  StyleIcon,
} from './LargeRectangleBloc.styled'
import LargeRectangleText from '../LargeRectangleText/LargeRectangleText'
import useCtaLink from '../../hooks/useCtaLink'
import { formatSizeUnits } from '../../utils/BytesToMo'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'
import { NAVBAR_HEIGHT } from '../../theme/constants'
import { APP_AERO_URL, APP_AUTO_URL } from '../../config/AppAutoAero'

const LargeRectangleBloc = (props) => {
  const {highlight, index, setTappedCard, setShow, locale, browser, mobileSystem, location} = props
  let formatDescription = ''
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const isTablet = useMediaQuery(deviceMax.tablet)
  const id = highlight.hashSlug
  const isPair = index % 2 === 0
  const alignment = alignmentMatcher[highlight.textAlignment]
  const docExists = highlight.document && highlight.document.name && highlight.document.cloudinary
  const hightLightUrl = highlight.cta?.urlAppAuto ? APP_AUTO_URL : highlight.cta?.urlAppAero ? APP_AERO_URL : highlight.cta?.url
  const ctaExists = highlight.cta?.label && hightLightUrl
  const blockRef = useRef(null)
  const navbarHeight = isTablet ? NAVBAR_HEIGHT.mobile : NAVBAR_HEIGHT.desktop

  const [ctaUrl, ctaSlug] =
    highlight.cta && hightLightUrl
      ? useCtaLink(hightLightUrl)
      : [null, null]

  if (docExists) {
    const size = formatSizeUnits(highlight.document.cloudinary[0].bytes)
    formatDescription =
      highlight.document.cloudinary[0].format.toUpperCase() + ' - ' + size
  }
  const variant =
    highlight.buttonVariant === null
      ? ButtonVariantEnum.primary
      : buttonVariantMacher[highlight.buttonVariant]
  const image = NormalizeMedia(highlight.image, isMobile)

  const counterButton = (ctaExists && docExists)
    ? 2
    : (ctaExists || docExists)
      ? 1
      : 0


  useEffect(() => {
    if (blockRef && blockRef.current && location?.hash) {
      if (blockRef.current.id === location.hash.replace('#', '')) {
        const y = blockRef.current.offsetTop - Number(navbarHeight) - Number(navbarHeight)
        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    }
  }, [blockRef.current])


  return (
    <StyledCard ref={blockRef} id={id} key={index + 'card'} $isPair={isPair} $hasMargin={props.hasMargin} $hasImage={!!image}>
      {image && <StyledImage>{image}</StyledImage>}
      <StyledBody key={index + 'body'} $hasImage={!!image}>
        {highlight.title && (
          <StyledHeading
            id={id}
            key={index + 'heading'}
            label={highlight.title.title}
            size={HeadingSizeEnum.h3}
          />
        )}
        {highlight.textHtml && (
          <LargeRectangleText
            alignment={alignment}
            highlight={highlight}
            index={index}
            isPair={isPair}
            counterButton={counterButton}
            hasButton={highlight.document != null || highlight.cta !== null}
            locale={locale}
            setTappedCard={setTappedCard}
            setShow={setShow}
            mobileSystem={mobileSystem}
            browser={browser}
          />
        )}
        {(ctaExists || docExists) && (
          <StyledButtons>
            {docExists && (
              <StyledButtonDownload
                name={highlight.document.name}
                description={formatDescription}
                document={highlight.document}
                hasDownloadIcon={false}
              />
            )}
            {ctaExists && (
              <StyledButton
                key={index + 'button'}
                href={ctaUrl}
                to={ctaSlug}
                variant={variant}
                target={ctaUrl && '_blank'}
              >
                <StyledLabel key={index + 'label'}>{highlight.cta?.label}</StyledLabel>
                <StyleIcon key={index + 'icon'}/>
              </StyledButton>
            )}
          </StyledButtons>)}
      </StyledBody>
    </StyledCard>
  )
}
export default LargeRectangleBloc
